import React, {
  memo, useRef, useEffect, useCallback,
} from 'react';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import { UploadCloud } from 'react-feather';
import './card-file-upload.scss';
import useTranslation from '../../../../../utils/translation-utils';
import FeaturedIcon, {
  FeaturedIconSizes,
  FeaturedIconColors,
} from '../../../featured-icon/featured-icon';
import Typography from '../../../typography';
import Button, { ButtonSizes } from '../../../button';

const CardFileUpload = ({
  disabled, primaryMsg, supportingMsg, allFilesUploaded, isDialogOpen,
}) => {
  const uploadBtnRef = useRef();
  const [getTranslation] = useTranslation();
  const uploadDialogOpenRef = useRef(false);

  useEffect(() => {
    if (!isDialogOpen && uploadDialogOpenRef.current) {
      uploadDialogOpenRef.current = false;
    }
  }, [isDialogOpen]);

  const handleContentClick = useCallback((event) => {
    if (event.currentTarget === uploadBtnRef.current) {
      uploadDialogOpenRef.current = true;
    } else if (!uploadDialogOpenRef.current) {
      event.preventDefault();
      event.stopPropagation();
    }
  }, []);

  return (
    <div className={clsx('card-file-section', { disabled })} onClick={handleContentClick}>
      <FeaturedIcon
        type={UploadCloud}
        className="cfs-featured-icon"
        size={FeaturedIconSizes.SMALL}
        color={FeaturedIconColors.DARK}
      />
      <div className="cfs-message">
        <Typography
          className="fsm-primary-msg"
          variant={Typography.Variants.sm}
          color={Typography.Colors.gray700}
          fontWeight={Typography.FontWeight.medium}
        >
          {primaryMsg || getTranslation('UPLOAD_FILES_HERE')}
        </Typography>
        <Typography
          className="fsm-supporting-msg"
          variant={Typography.Variants.xs}
          color={Typography.Colors.gray500}
          fontWeight={Typography.FontWeight.regular}
        >
          {supportingMsg}
        </Typography>
      </div>
      <Button
        ref={uploadBtnRef}
        className="cfs-upload-btn"
        size={ButtonSizes.XX_SMALL}
        onClick={handleContentClick}
        label={getTranslation('UPLOAD')}
        disabled={allFilesUploaded || disabled}
      />
    </div>
  );
};

CardFileUpload.defaultProps = {
  primaryMsg: '',
  disabled: false,
  supportingMsg: '',
  isDialogOpen: false,
  allFilesUploaded: false,
};

CardFileUpload.propTypes = {
  disabled: PropTypes.bool,
  primaryMsg: PropTypes.string,
  isDialogOpen: PropTypes.bool,
  supportingMsg: PropTypes.string,
  allFilesUploaded: PropTypes.bool,
};

export default memo(CardFileUpload);
